import {
    AUTH_SIGNIN_USER,
    AUTH_SIGNIN_USER_SUCCESS,
    AUTH_LOGOUT_USER,
    AUTH_TOKEN_LOGOUT_USER,
} from '../types/loginTypes'

const initialState = {
    loginUsers: {}
}

const loginReducer = (state = initialState, action) => {

    switch (action.type) {
        case AUTH_SIGNIN_USER:
            return {
                ...state,
                loginUsers: action.user,
            }
        case AUTH_SIGNIN_USER_SUCCESS:
            return {
                ...state,
                loginUsers: action.payload
            }
        case AUTH_LOGOUT_USER:

            if (+state.loginUsers.customerNo != 1158) {
                window.location.href = '/'
            }
            else {
                window.location.href = `${process.env.REACT_APP_SNOWLINK}`
            }
            return {
                ...state,
                loginUsers: {},
            }
        case AUTH_TOKEN_LOGOUT_USER:
            return {
                ...state,
                loginUsers: {},
            }
        default: return state
    }
}
export default loginReducer